<template>
  <div
    class="flex py-4 items-baseline"
  >
    <div class="mr-2 custom-height flex items-center"><Plus :theme="theme" /></div>
    <div
      :class="{'text-grey': (theme === 'grey'), 'text-orange': (theme === 'orange')}"
      class="leading-normal cursor-pointer"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import Plus from './icons/Plus.vue';

export default {
  name: 'BaseAddLine',
  components: {
    Plus,
  },
  props: {
    theme: {
      type: String,
      validator(value) {
        return ['grey', 'orange'].indexOf(value) !== -1;
      },
      default: 'grey',
    },
  },
};
</script>
